import { ActivatedRoute } from '@angular/router';
import { InfluencerService } from '../../../services/influencer/influencer.service';
import { CommonConstant, kpiAttributes, platformIconPath } from '../../../app.constants';
import { InfluencerIgStoryLoadingStatus } from '../../../../models/influencer';
import { concatMap, filter, take } from 'rxjs/operators';
import { timer } from 'rxjs/observable/timer';
import { AchooPopupComponent } from '../../../core/achoo-popup/achoo-popup.component';
import { ModalService } from '../../../services/modal/modal.service';
import { TranslateService } from '@ngx-translate/core';
import { UserService } from '../../../services/user.service';
import { PdfExportService } from '../../../services/export-pdf/pdf-export.service';
import { DateUtils } from '../../../utils/date.utils';
import { CacheService } from '../../../services/cache/cache.service';
import { ActivePages, EventTrackerService, Page, TargetType, UserActionType } from '../../../services/event-tracker/event-tracker.service';
import { InfluencerPostsComponent } from './influencer-posts/influencer-posts.component';
import { Subject } from 'rxjs/Subject';
import { combineLatest } from 'rxjs/observable/combineLatest';
var StoryStatus;
(function (StoryStatus) {
    StoryStatus["SUCCESS"] = "SUCCESS";
    StoryStatus["ERROR"] = "ERROR";
})(StoryStatus || (StoryStatus = {}));
var StoryStatusDetails;
(function (StoryStatusDetails) {
    StoryStatusDetails["GOT_STORIES"] = "GOT STORIES";
    StoryStatusDetails["NO_STORIES"] = "NO STORIES";
    StoryStatusDetails["TIMEOUT"] = "TIMEOUT";
    StoryStatusDetails["SERVER_ERROR"] = "SERVER_ERROR";
})(StoryStatusDetails || (StoryStatusDetails = {}));
var InfluencerOverviewComponent = /** @class */ (function () {
    function InfluencerOverviewComponent(influencerService, eventTracker, modalService, translate, userService, pdfExportService, cacheService, route) {
        var _this = this;
        this.influencerService = influencerService;
        this.eventTracker = eventTracker;
        this.modalService = modalService;
        this.translate = translate;
        this.userService = userService;
        this.pdfExportService = pdfExportService;
        this.cacheService = cacheService;
        this.route = route;
        this.isFetchingInfluencerPostList = true;
        this.noDataAvailabel = false;
        this.isFetchingInfluencerDetails = true;
        // latest posts
        this.latestPosts = [];
        this.isFetchingLatestPosts = true;
        // brand mentions
        this.brandMentions = [];
        // sponsored vs organic
        this.sponsoredOrganicPercentage = [];
        this._influencerInitializedSubject = new Subject();
        // update data after check credit availability from calling `GET /influencer`
        this._cachedInfluencerUpdatedSubscription = combineLatest([
            influencerService.cachedInfluencerUpdated,
            this._influencerInitializedSubject
        ]).subscribe(function (_a) {
            var inf = _a[0];
            if (Number(inf.influencerId) !== Number(_this.influencerId)) {
                return;
            }
            _this.brandMentions = inf.brandMentions;
            _this.relatedInfluencers = inf.relatedInfluencers;
            _this.sponsoredOrganicPercentage = inf.sponsoredOrganicPercentage;
        });
    }
    InfluencerOverviewComponent.prototype.ngOnInit = function () {
        var _this = this;
        this.isVisibleTopicChart = false;
        this.loadInfluencerDetails(this.influencerId);
        this.getInfluencerPosts(this.influencerId);
        this.getLatestPosts(this.influencerId);
        // handle for IG story
        if (this.influencerService.influencerDetails) {
            // segment track event
            this.eventTracker.trackUserAction(UserActionType.VIEW, Page.INFLUENCER_OVERVIEW, {
                id: this.influencerService.influencerDetails.id,
                name: this.influencerService.influencerDetails.name,
                type: TargetType.INFLUENCER
            }, undefined, undefined, {
                type: ActivePages.INFLUENCER_OVERVIEW,
                name: this.influencerService.influencerDetails.name,
                id: this.influencerService.influencerDetails.id
            });
        }
        this.route.queryParams.subscribe(function (params) {
            _this.groupId = params.group_id;
        });
        this.fetchedNewStoryDone = false;
        this.registerIgStorySubscription();
    };
    InfluencerOverviewComponent.prototype.getInfluencerPosts = function (influencerId) {
        var _this = this;
        var postListParams = {
            limit: CommonConstant.LIMIT_20,
            period: CommonConstant.PERIOD_183_DAYS,
            orderBy: kpiAttributes.engagement
        };
        var cachingKey = "influencer_posts_" + influencerId;
        this.cacheService.get(cachingKey, this.influencerService.getInfluencerPosts(influencerId, postListParams))
            .subscribe(function (data) {
            _this.isFetchingInfluencerPostList = false;
            if (!data) {
                return;
            }
            data.sort(function (a, b) { return b.engagement - a.engagement; });
            var postList = data.slice(0, CommonConstant.LIMIT_20);
            postList.forEach(function (item) {
                if (item.title) {
                    item.title = item.title.replace(/\uFFFD/g, ''); // remove unknown character
                    item.title = item.title.substring(0, 100) + '...'; // get 100 characters
                }
            });
            _this.influencerPostList = postList;
            _this.preloadingPostImage(postList, function () {
                _this.readyToShowPost = true;
                // don't fetch new stories when exporting pdf or freemium or basic user
                if (_this.userService.isFreeUser() || _this.pdfExportService.exportingPdf) {
                    return;
                }
                var cachedNewStory = _this.influencerService.getLatestNewStory();
                if (!cachedNewStory || cachedNewStory.influencerId !== influencerId) {
                    var igChannelArr = _this.filterIGChannel();
                    if (igChannelArr && igChannelArr.length > 0) {
                        _this.startFetchingStoryTime = new Date().getTime();
                        _this.fetchIgNewStories();
                    }
                }
            });
        }, function (error) {
            _this.errorMessage = error;
            _this.isFetchingInfluencerPostList = false;
        });
    };
    InfluencerOverviewComponent.prototype.preloadingPostImage = function (postList, allImagesLoadedCallback) {
        var loadedCounter = 0;
        var toBeLoadedNumber = postList.length;
        if (toBeLoadedNumber === 0) {
            allImagesLoadedCallback();
        }
        else {
            postList.forEach(function (post) {
                preloadImage(post.imageUrl, function () {
                    loadedCounter++;
                    if (loadedCounter === toBeLoadedNumber) {
                        console.log('all images loaded : ' + loadedCounter);
                        allImagesLoadedCallback();
                    }
                });
            });
        }
        function preloadImage(url, anImageLoadedCallback) {
            var img = new Image();
            img.src = url;
            img.onload = anImageLoadedCallback;
            img.onerror = anImageLoadedCallback;
        }
    };
    InfluencerOverviewComponent.prototype.onChangeChannel = function (channel) {
        this.influencerService.updateActiveChannel(channel);
    };
    /**
     * Subscribe ig story event, update UI anytime event fire
     */
    InfluencerOverviewComponent.prototype.registerIgStorySubscription = function () {
        var _this = this;
        this.igStoryLoadingSubscription = this.influencerService.loadingNewStoriesEvent.subscribe(function (newStatus) {
            if (newStatus === InfluencerIgStoryLoadingStatus.DONE) {
                var presentingPostUrlHashes_1 = _this.influencerPostList.map(function (post) { return post.urlHash; });
                // get new stories which not presented yet
                var newStoriesToPresent = _this.influencerService.getNewIgStories()
                    .filter(function (newStory) { return presentingPostUrlHashes_1.indexOf(newStory.urlHash) < 0; });
                // get new stories which are presenting
                var newStoriesPresenting = _this.influencerService.getNewIgStories()
                    .filter(function (newStory) { return presentingPostUrlHashes_1.indexOf(newStory.urlHash) >= 0; });
                // transform new stories before present in post list
                var newStories = _this.influencerService.transformDiscoverPostDataIntoInfluencerPost(newStoriesToPresent, false);
                // update data of existing story
                _this.updateDataOfExistingStory(newStoriesPresenting);
                // clear polling timeout for new stories
                clearTimeout(_this.pollingNewStoryTimeout);
                // start timeout for polling incompleted stories after 3 minutes
                _this.stopPollingIncompletedStory(180000);
                // not show notification when new stories have been done
                if (_this.fetchedNewStoryDone) {
                    return;
                }
                _this.fetchedNewStoryDone = true;
                _this.endFetchingStoryTime = new Date().getTime();
                var executionTime = (_this.endFetchingStoryTime - _this.startFetchingStoryTime) / 1000;
                if (newStories.length > 0) {
                    // prepend to mansory list
                    if (_this.influencerPosts && _this.influencerPosts.mansoryPostListContainer) {
                        _this.influencerPosts.mansoryPostListContainer.prependItems(newStories);
                    }
                    // show notification
                    if (newStories.length > 1) {
                        _this.showStorySuccessNotification(_this.translate.instant('story.success.message_multiple', {
                            numOfStory: newStories.length
                        }));
                    }
                    else {
                        _this.showStorySuccessNotification(_this.translate.instant('story.success.message_single'));
                    }
                    // report to Segment
                    _this.trackStoryEventOnSegement(_this.influencerDetails.name, _this.influencerDetails.id, StoryStatus.SUCCESS, StoryStatusDetails.GOT_STORIES, newStories.length, executionTime);
                }
                else {
                    _this.showStorySuccessNotification(_this.translate.instant('story.success.message_no_story'));
                    _this.trackStoryEventOnSegement(_this.influencerDetails.name, _this.influencerDetails.id, StoryStatus.SUCCESS, StoryStatusDetails.NO_STORIES, 0, executionTime);
                }
            }
        });
    };
    /**
     * fetch details of influencer
     * @param influencerId
     */
    InfluencerOverviewComponent.prototype.loadInfluencerDetails = function (influencerId) {
        var _this = this;
        this.cacheService.get("influencer_" + this.influencerId, this.influencerService.getInfluencer(influencerId)).subscribe(function (data) {
            var influencer = data;
            _this.influencerDetails = influencer;
            _this.relatedInfluencers = influencer.relatedInfluencers;
            _this.brandMentions = influencer.brandMentions;
            _this.sponsoredOrganicPercentage = influencer.sponsoredOrganicPercentage;
            var popularTopic = new Array();
            var topMention = new Array();
            if (influencer.topTopics && Array.isArray(influencer.topTopics)) {
                influencer.topTopics.forEach(function (topic) {
                    if (topic.name && topic.name !== 'NA' && topic.name !== 'Other' && Math.round(topic.percent * 1000) / 10 !== 0) {
                        popularTopic.push({ name: topic.name, y: topic.percent });
                    }
                });
            }
            _this.popularTopic = popularTopic;
            if (influencer.topMentions && Array.isArray(influencer.topMentions)) {
                influencer.topMentions.forEach(function (mention) {
                    topMention.push({
                        keyword: mention.mention,
                        number: mention.count,
                    });
                });
            }
            _this.isVisibleTopicChart = influencer.topTopics != null && influencer.topTopics.length > 0;
            _this.noDataAvailabel = _this.popularTopic.length === 0;
            _this.isFetchingInfluencerDetails = false;
            _this._influencerInitializedSubject.next(null);
        }, function (error) {
            _this.isFetchingInfluencerDetails = false;
            _this.errorMessage = error;
        });
    };
    InfluencerOverviewComponent.prototype.updateDataOfExistingStory = function (newStoriesPresenting) {
        var _this = this;
        newStoriesPresenting.forEach(function (ns) {
            if (ns.completed) {
                var presentingStory = _this.influencerPostList.find(function (ip) { return ip.urlHash === ns.urlHash; });
                presentingStory.completed = true;
                presentingStory.reach = ns.reach;
                presentingStory.impact = ns.impact * 100;
                presentingStory.engagement = ns.engagement;
                presentingStory.url = ns.fullUrl;
            }
        });
    };
    InfluencerOverviewComponent.prototype.ngOnDestroy = function () {
        if (this.igStoryLoadingSubscription) {
            this.igStoryLoadingSubscription.unsubscribe();
        }
        if (this.pollingSubscription) {
            this.pollingSubscription.unsubscribe();
        }
        if (this.pollingNewStoryTimeout) {
            clearTimeout(this.pollingNewStoryTimeout);
        }
        if (this.pollingIncompletedTimeout) {
            clearTimeout(this.pollingIncompletedTimeout);
        }
        if (this.channelSubscription) {
            this.channelSubscription.unsubscribe();
        }
        if (this.fetchNewIgStoriesSubscription) {
            this.fetchNewIgStoriesSubscription.unsubscribe();
        }
        this._cachedInfluencerUpdatedSubscription.unsubscribe();
        this.modalService.close();
    };
    InfluencerOverviewComponent.prototype.fetchIgNewStories = function () {
        var _this = this;
        var lastSeenDate = this.extractTheLastSeenDate();
        this.fetchNewIgStoriesSubscription = this.influencerService.fetchNewIgStories(this.influencerId, lastSeenDate)
            .subscribe(function (res) {
            if (res) {
                _this.pollNewIgStoriesUntilFinish(_this.influencerId, res.id, lastSeenDate);
                _this.stopPollingAfterIntervalTime(30000);
            }
        }, function (err) {
            if (err.error.data === 'missing_source_id' || err.error.data === 'not_found_channel') {
                _this.showStoryErrorNotification('story.error.missing_source_id');
            }
            else {
                _this.showStoryErrorNotification('story.error.server_error');
            }
            _this.trackStoryEventOnSegement(_this.influencerDetails.name, _this.influencerDetails.id, StoryStatus.ERROR, StoryStatusDetails.SERVER_ERROR);
        });
    };
    InfluencerOverviewComponent.prototype.extractTheLastSeenDate = function () {
        return Array.isArray(this.influencerPostList) && this.influencerPostList.length > 0 ? this.influencerPostList[0].date : null;
    };
    InfluencerOverviewComponent.prototype.stopPollingAfterIntervalTime = function (timeout) {
        var _this = this;
        this.pollingNewStoryTimeout = setTimeout(function () {
            if (_this.pollingSubscription) {
                _this.pollingSubscription.unsubscribe();
                _this.influencerService.updateNewIgStoryStatus(InfluencerIgStoryLoadingStatus.ERROR);
                _this.showStoryErrorNotification('story.error.server_error');
                _this.trackStoryEventOnSegement(_this.influencerDetails.name, _this.influencerDetails.id, StoryStatus.ERROR, StoryStatusDetails.TIMEOUT);
            }
        }, timeout);
    };
    InfluencerOverviewComponent.prototype.stopPollingIncompletedStory = function (timeout) {
        var _this = this;
        this.pollingIncompletedTimeout = setTimeout(function () {
            if (_this.pollingSubscription) {
                _this.pollingSubscription.unsubscribe();
            }
        }, timeout);
    };
    InfluencerOverviewComponent.prototype.checkingPollingFinish = function (responseData) {
        if (responseData.status === InfluencerIgStoryLoadingStatus.ERROR) {
            return true;
        }
        var numOfIncompleted = responseData.newIgStories.filter(function (s) { return !s.completed; }).length;
        var isFinished = responseData.status === InfluencerIgStoryLoadingStatus.DONE &&
            numOfIncompleted === 0;
        if (responseData.status === InfluencerIgStoryLoadingStatus.DONE) {
            console.log("Done but still have " + numOfIncompleted + " NOT completed");
        }
        return isFinished;
    };
    InfluencerOverviewComponent.prototype.pollNewIgStoriesUntilFinish = function (influencerId, loaderId, lastSeenDate) {
        var _this = this;
        this.pollingSubscription = timer(0, 5000)
            .pipe(concatMap(function () { return _this.influencerService.fetchNewIgStories(influencerId, lastSeenDate, loaderId); }))
            .pipe(filter(function (data) { return data && _this.checkingPollingFinish(data); }))
            .pipe(take(1))
            .subscribe(function (res) {
            if (res.status === InfluencerIgStoryLoadingStatus.ERROR) {
                _this.showStoryErrorNotification('story.error.server_error');
                _this.trackStoryEventOnSegement(_this.influencerDetails.name, _this.influencerDetails.id, StoryStatus.ERROR, StoryStatusDetails.SERVER_ERROR);
            }
        });
    };
    InfluencerOverviewComponent.prototype.showStoryErrorNotification = function (errorMsgKey) {
        if (this._storyErrorMessage !== errorMsgKey) {
            this._storyErrorMessage = errorMsgKey;
            this.modalService.open(this.notificationFetchingStoryError, this.closeNotification.bind(this), true, 30000);
        }
    };
    InfluencerOverviewComponent.prototype.showStorySuccessNotification = function (successMsg) {
        this._storySuccessMessage = successMsg;
        this.modalService.open(this.notificationGetNewStorySuccess, this.closeNotification.bind(this), true, 30);
    };
    InfluencerOverviewComponent.prototype.trackStoryEventOnSegement = function (influencerName, influencerId, status, details, storyCount, fetchingTime) {
        this.eventTracker.trackUserAction(UserActionType.ACTION, Page.INFLUENCER_DETAILS, {
            id: influencerId,
            name: influencerName,
            type: Page.IG_STORY
        }, {
            action: UserActionType.FETCH,
            action_status: status,
            action_status_details: details,
            action_stories_count: storyCount,
            action_stories_timing: fetchingTime
        });
    };
    InfluencerOverviewComponent.prototype.openIncompletedStoryWarning = function (post) {
        var hourDiff = DateUtils.computeTimeDiffInHour(new Date(post.date), new Date());
        if (hourDiff > 24) {
            this._storyIcompleteMessage = this.translate.instant('story.error.incompleted_over_24h');
        }
        else {
            this._storyIcompleteMessage = this.translate.instant('story.error.incompleted');
        }
        this.modalService.open(this.warningOpenIncompletedStory, null, false);
    };
    Object.defineProperty(InfluencerOverviewComponent.prototype, "storyErrorMessage", {
        get: function () {
            return this._storyErrorMessage;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(InfluencerOverviewComponent.prototype, "storySuccessMessage", {
        get: function () {
            return this._storySuccessMessage;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(InfluencerOverviewComponent.prototype, "storyIncompleteMessage", {
        get: function () {
            return this._storyIcompleteMessage;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(InfluencerOverviewComponent.prototype, "isExportingPdf", {
        get: function () {
            return this.pdfExportService.exportingPdf;
        },
        enumerable: true,
        configurable: true
    });
    InfluencerOverviewComponent.prototype.closeNotification = function () {
        this._storyErrorMessage = null;
        this._storySuccessMessage = null;
        this.modalService.close();
    };
    InfluencerOverviewComponent.prototype.filterIGChannel = function () {
        if (this.influencerDetails && this.influencerDetails.channels && this.influencerDetails.channels.length > 0) {
            return this.influencerDetails.channels.filter(function (item) { return item.platform.id === platformIconPath.instagram.id; });
        }
        return [];
    };
    //#region Latest Posts
    /**
     * fetch post list of influencer in 30 days based on channel
     * @param influencerId
     * @param activeChannel
     */
    InfluencerOverviewComponent.prototype.getLatestPosts = function (influencerId) {
        var _this = this;
        var postListParams = {
            limit: CommonConstant.LIMIT_INFLUENCER_POST_OVERVIEW,
            period: CommonConstant.PERIOD_30_DAYS
        };
        var cachingKey = "influencer_latest_posts_" + influencerId;
        // get post list by channel
        this.cacheService.get(cachingKey, this.influencerService.getInfluencerPosts(influencerId, postListParams))
            .subscribe(function (res) {
            _this.latestPosts = res.sort(function (a, b) { return b.date - a.date; }).slice(0, CommonConstant.LIMIT_INFLUENCER_POST_OVERVIEW);
            _this.isFetchingLatestPosts = false;
        }, function (err) {
            _this.latestPosts = [];
            _this.isFetchingLatestPosts = false;
        });
    };
    return InfluencerOverviewComponent;
}());
export { InfluencerOverviewComponent };



// WEBPACK FOOTER //
// ./src/app/main/influencer/influencer-overview/influencer-overview.component.ts.pre-build-optimizer.js